export default __webpack_public_path__ + "static/media/email_success.515620d4.svg";